import { Option } from "../Select/Select";
import { useEventEmitter } from "../useEventEmitter";
import { Props as DateRangeProps } from "./DateRange";

export interface UseDateRangeWithReportingYears {
  selectedReportingYear?: Option<string> & {
    startDate: string;
    endDate: string;
    reportingYearId?: string;
  };
  handleSelect: (value: string) => void;
  closePopoverEvent: ReturnType<typeof useEventEmitter<void>>;
}

interface Props extends DateRangeProps {
  reportingYears: (Option<string> & { startDate: string; endDate: string })[];
}

export const useDateRangeWithReportingYears = (
  props: Props
): UseDateRangeWithReportingYears => {
  const { reportingYears, value, onChange } = props;

  const closePopoverEvent = useEventEmitter<void>();

  const selectedReportingYear = reportingYears.find(
    (option) =>
      option.startDate === value?.start && option.endDate === value?.end
  );

  const handleSelect = (value: string) => {
    const selectedOption = reportingYears.find(
      (option) => option.value === value
    );

    if (selectedOption) {
      onChange?.(
        selectedOption.startDate,
        selectedOption.endDate,
        selectedOption.value
      );
    }
    closePopoverEvent.emit();
  };

  return { selectedReportingYear, handleSelect, closePopoverEvent };
};
